<template>
  <b-container class="div-background" fluid>
    <b-breadcrumb :items="breadcrumbItems" class="minus-gutters"></b-breadcrumb>
    <b-alert
      variant="success"
      :show="messageObject.success.count"
      dismissible
      @dismissed="messageObject.success.count = 0"
      @dismiss-count-down="successCountChanged"
      >{{ messageObject.success.content }}
    </b-alert>
    <!-- <b-alert variant="warning" show>等待資訊</b-alert> -->
    <div class="Info_Area">
      <b-container fluid>
        <b-row>
          <b-col>
            <b-row>
              <b-col>
                <!-- <b-button
                  v-if="showmanage.add"
                  @click="
                    $router.push({ path: '/databuildaddforfishcatchnew/add' })
                  "
                  variant="warning"
                  >新增價格</b-button
                > -->
              </b-col>
              <b-col cols="auto" style="display: inline-flex;">
                <label style="margin-right: 0.5rem;">
                  <label for="file" class="btn btn-success">匯入</label>
                  <input
                    @change="uploadFile"
                    id="file"
                    type="file"
                    style="display: none;"
                  />
                </label>
                <export-excel
                  :data="exceldata.dataset"
                  :fields="exceldata.fields"
                  :worksheet="exceldata.filename"
                  :name="exceldata.filename + getNow()"
                  >
                  <b-button style="padding-right: 10px; margin-right: 0.5rem;" variant="warning"
                    >匯出</b-button>
                </export-excel>
                <a
                    href="https://agri-data.cyhg.gov.tw/uplode/112%e6%bc%81%e6%a5%ad%e7%a7%91-%e8%b3%87%e6%96%99%e5%8c%af%e5%85%a5%e7%af%84%e6%9c%ac.xlsx"
                    download="漁業科-匯入檔範本.xlsx"
                  >
                  <b-button>範本下載</b-button>
                </a>
              </b-col>
            </b-row>
            <b-row>
              <div class="container-fluid">
                <div class="index-top-info">
                  <b-form inline>
                    <b-input-group>
                      <label class="sr-only"
                        >Name</label
                      >
                      <b-input-group-text>
                        <b-icon icon="calendar3"></b-icon>
                      </b-input-group-text>
                      <datepicker
                        v-model="timepicker.minvalue"
                        min="1960-01-01"
                      ></datepicker>
                    </b-input-group>
                    <span>~</span>
                    <b-input-group style="margin-right: 0.5rem;">
                      <label class="sr-only"
                        >Name</label
                      >
                      <b-input-group-text>
                        <b-icon icon="calendar3"></b-icon>
                      </b-input-group-text>
                      <datepicker
                        v-model="timepicker.maxvalue"
                        :min="twtimeparse(timepicker.minvalue)"
                      ></datepicker>
                    </b-input-group>
                    <v-select
                      style="min-width: 8rem;margin-right: 0.5rem;"
                      v-model="fishcatch.value"
                      :options="fishcatch.options"
                    ></v-select>
                    <b-button @click="filteritems" variant="warning"
                      >查詢</b-button
                    >
                  </b-form>
                </div>
              </div>
            </b-row>
            <b-row>
              <!-- <b-col style="height: 30px">*批發交易行情取最近一日之台北一交易資料</b-col> -->
              <!-- <b-col style="height: 30px">*以下皆為假資料</b-col> -->
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="auto">
            <b-table
              :items="priceanalysis.items"
              :fields="
                window.width < 1024
                  ? priceanalysis.fields_mobile
                  : priceanalysis.fields
              "
              :per-page="perPage"
              :current-page="currentPage"
              :busy="isBusy"
              responsive="sm"
              striped
              bordered
              outlined
              hover
              head-variant="dark"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
              <template #cell(FM_PRICE_L)="data">
                {{ data.item.FM_PRICE_L }} - {{ data.item.FM_PRICE_R }}
              </template>
              <template #cell(FM_PRICE_L_TW)="data">
                {{ data.item.FM_PRICE_L_TW }} - {{ data.item.FM_PRICE_R_TW }}
              </template>
              <template #cell(EDIT)="data">
                <b-button
                  v-if="window.width < 1024"
                  variant="success"
                  style="margin-bottom: 0.1rem; margin-right: 0.1rem;"
                  @click="data.toggleDetails"
                >
                  {{ data.detailsShowing ? "隱藏" : "詳細" }}
                </b-button>
                <!-- <b-button
                  v-if="showmanage.edit"
                  @click="changePage(data)"
                  style="margin-bottom: 0.1rem;"
                  variant="warning"
                  >編輯</b-button
                >-->
              </template> 
              <template #row-details="row">
                <b-card>
                  <template v-if="window.width < 1024">
                    <b-row class="mb-2">
                      <b-col sm="3" class="text-sm-right"
                        ><b>交易行情平均價(元/公斤):</b></b-col
                      >
                      <b-col>{{ row.item.PRICE_AVG }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="3" class="text-sm-right"
                        ><b>收成規格:</b></b-col
                      >
                      <b-col>{{ row.item.FISH_SPEC }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="3" class="text-sm-right"
                        ><b>池邊價格(元/公斤):</b></b-col
                      >
                      <b-col
                        >{{ row.item.FM_PRICE_L }} -
                        {{ row.item.FM_PRICE_R }}</b-col
                      >
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="3" class="text-sm-right"
                        ><b>池邊價格(元/台斤):</b></b-col
                      >
                      <b-col
                        >{{ row.item.FM_PRICE_L_TW }} -
                        {{ row.item.FM_PRICE_R_TW }}</b-col
                      >
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="3" class="text-sm-right"><b>備註:</b></b-col>
                      <b-col>{{ row.item.FM_NOTES }}</b-col>
                    </b-row>
                    <b-button variant="success" @click="row.toggleDetails"
                      >隱藏</b-button
                    >
                  </template>
                </b-card>
              </template>
            </b-table>
            <b-pagination
              v-show="totalRows > perPage"
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              aria-controls="companyList"
              align="center"
            >
            </b-pagination>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </b-container>
</template>
<script>
import FISHCODELIST from "@/data/FISH_CODE_LIST.json";
import datepicker from "@/components/Datepicker.vue";

export default {
  data() {
    var date = new Date();
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const maxDate = new Date(today);
    const minDate = new Date(today);
    minDate.setDate(date.getDate() - 7);
    var taiwanMinDate = minDate
      .toLocaleString()
      .split(" ")[0]
      .split("/");
    taiwanMinDate[0] = parseInt(taiwanMinDate[0]) - 1911;
    taiwanMinDate[1] =
      taiwanMinDate[1].length == 1 ? 0 + taiwanMinDate[1] : taiwanMinDate[1];
    taiwanMinDate[2] =
      taiwanMinDate[2].length == 1 ? 0 + taiwanMinDate[2] : taiwanMinDate[2];
    var taiwanMaxDate = maxDate
      .toLocaleString()
      .split(" ")[0]
      .split("/");
    taiwanMaxDate[0] = parseInt(taiwanMaxDate[0]) - 1911;
    taiwanMaxDate[1] =
      taiwanMaxDate[1].length == 1 ? 0 + taiwanMaxDate[1] : taiwanMaxDate[1];
    taiwanMaxDate[2] =
      taiwanMaxDate[2].length == 1 ? 0 + taiwanMaxDate[2] : taiwanMaxDate[2];
    return {
      perPage: 10,
      currentPage: 1,
      filterSearch: null,
      fishcodelist: FISHCODELIST,
      sortBy: "CM_DATE",
      selection: [],
      totalRows: 1,
      isBusy: false,
      timepicker: {
        minvalue: taiwanMinDate.join("-"),
        maxvalue: taiwanMaxDate.join("-"),
        max: maxDate
          .toLocaleString()
          .split(" ")[0]
          .split("/")
          .join("-"),
      },
      filtervalue: null,
      datamanagement: {
        ifshow: false,
        ifedit: false,
      },
      breadcrumbItems: [
        {
          text: "首頁",
          href: "#/",
        },
        {
          text: "資料管理",
          active: true,
        },
        {
          text: "漁產品價格維護",
          active: true,
        },
      ],
      exceldata: {
        fields: {
          日期: "FM_DATE",
          魚種: "FISH_NAME",
          "交易行情平均價(元/公斤)": "PRICE_AVG",
          收成規格: "FISH_SPEC",
          "池邊低價格 (元/公斤)": "FM_PRICE_L",
          "池邊高價格 (元/公斤)": "FM_PRICE_R",
          "池邊低價格 (元/台斤)": "FM_PRICE_L_TW",
          "池邊高價格 (元/台斤)": "FM_PRICE_R_TW",
          備註: "FM_NOTES",
        },
        dataset: [],
        filename: "漁產品價格清單",
      },
      priceanalysis: {
        fields: [
          {
            key: "FM_DATE",
            label: "日期",
            visible: true,
          },
          {
            key: "FISH_NAME",
            label: "魚種",
            visible: true,
          },
          {
            key: "PRICE_AVG",
            label: "交易行情平均價(元/公斤)",
            visible: true,
          },
          {
            key: "FISH_SPEC",
            label: "收成規格",
            visible: true,
          },
          {
            key: "FM_PRICE_L",
            label: "池邊價格 (元/公斤)",
            visible: true,
          },
          {
            key: "FM_PRICE_L_TW",
            label: "池邊價格 (元/台斤)",
            visible: true,
          },
          {
            key: "FM_NOTES",
            label: "備註",
            visible: true,
          },
          //{
          //  key: "EDIT",
          //  label: "操作",
          //  visible: true,
          //},
        ],
        fields_mobile: [
          {
            key: "FM_DATE",
            label: "日期",
            visible: true,
          },
          {
            key: "FISH_NAME",
            label: "魚種",
            visible: true,
          },
          {
            key: "EDIT",
            label: "操作",
            visible: true,
          },
        ],
        items: [],
        allitems: [
          {
            FM_DATE: "2021-05-26",
            FISH_NAME: "白蝦",
            PRICE_AVG: "195.4",
            FISH_SPEC: "50尾/斤",
            FM_PRICE: "80",
            FM_SORT: 0,
            FM_NOTES:
              "成本價(混養50-55元、半專養80-85元)，本縣主要產季7-11月。 尚未進入本縣盛產季節，價格於7月前將持續維持高價位。",
          },
          {
            FM_DATE: "2021-05-26",
            FISH_NAME: "金目鱸",
            PRICE_AVG: "92.2",
            FISH_SPEC: "1斤/尾",
            FM_PRICE: "50",
            FM_SORT: 1,
            FM_NOTES:
              "1.成本價45元，主要產季6月-翌年1月。 2.大魚在池量充足，加上外銷競爭力大，價格不易再上漲，惟仍可維持相當利潤。",
          },
          {
            FM_DATE: "2021-05-26",
            FISH_NAME: "加州鱸",
            PRICE_AVG: "102.8",
            FISH_SPEC: "1斤/尾",
            FM_PRICE: "60",
            FM_SORT: 2,
            FM_NOTES:
              "1.成本價40～45元，產季1-5月。2.大魚在池量合宜沒有過量，價格將維持高價位。",
          },
        ],
        additem: {},
      },
      messageObject: {
        warning: {
          content: null,
          count: 0,
        },
        success: {
          content: null,
          count: 0,
        },
        dismissSecs: 3,
      },
      window: {
        width: 1024,
        height: 0,
      },
      fishcatch: {
        options: [
          { label: "全部", code: "全部" },
          { label: "白蝦", code: "白蝦" },
          { label: "金目鱸", code: "金目鱸" },
          { label: "加州鱸", code: "加州鱸" },
        ],
        value: { label: "全部", code: "全部" },
      },
      showmanage: {
        show: false,
        add: false,
        edit: false,
        delete: false,
        count: 0,
      },
      apiFishManagementList: (data) =>
        this.userRequest.post("/API/Default/FishManagementList", data),
      apiFishExcelUpload: (data) =>
        this.userRequest.post("/API/Default/FishExcelUpload", data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }),
    };
  },
  created() {
    this.checkLogin();
    // window.addEventListener('resize', this.handleResize);
    // this.handleResize();
    // this.init();
    // this.priceanalysis.items = JSON.parse(JSON.stringify(this.priceanalysis.allitems))
    // this.exceldata.dataset = JSON.parse(JSON.stringify(this.priceanalysis.allitems))
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    // this.checkLogin()
    // this.checkPermission()
  },
  methods: {
    checkLogin() {
      let TokenID = sessionStorage.getItem("TokenID");
      if (TokenID) {
        this.checkPermission();
      } else {
        alert("無權限檢視此頁面，請登入帳號");
        this.$router.push({ path: "/login" });
      }
    },
    async checkPermission() {
      this.showmanage.count = 0;
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000010",
        fun: this.checkByPJIDshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000011",
        fun: this.checkByPJIDadd,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000012",
        fun: this.checkByPJIDedit,
      });
      // this.FunctionToken(this.Authority, {
      //   PJ_ID: "PJ000000000009",
      //   fun: this.checkByPJIDdelete,
      // });
    },
    // checkByPJID(value) {
    //   if (!value) {
    //     alert("無權限檢視此頁面，將返回首頁");
    //     this.$router.push({ path: "/" });
    //   } else {
    //     window.addEventListener("resize", this.handleResize);
    //     this.handleResize();
    //     this.init();
    //   }
    // },
    checkallpermission() {
      if (this.showmanage.show || this.showmanage.add || this.showmanage.edit) {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
        this.init();
      } else {
        alert("無權限檢視此頁面，將返回首頁");
        this.$router.push({ path: "/" });
      }
    },
    checkByPJIDshow(value) {
      this.showmanage.count++;
      if (value) this.showmanage.show = true;
    },
    checkByPJIDadd(value) {
      this.showmanage.count++;
      if (value) this.showmanage.add = true;
    },
    checkByPJIDedit(value) {
      this.showmanage.count++;
      if (value) this.showmanage.edit = true;
    },
    checkByPJIDdelete(value) {
      this.showmanage.count++;
      if (value) this.showmanage.delete = true;
    },
    FishManagementList(data) {
      this.apiFishManagementList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.priceanalysis.items = [];
            this.exceldata.dataset = [];
            let dataItems = JSON.parse(json.Data);
            if (dataItems.length != 0) {
              dataItems.sort((a, b) => {
                if (a.FM_DATE == b.FM_DATE) {
                  return (a.FM_SORT > b.FM_SORT) - (a.FM_SORT < b.FM_SORT);
                }
                return (a.FM_DATE < b.FM_DATE) - (a.FM_DATE > b.FM_DATE);
              });
              for (let i in dataItems) {
                let subitem = dataItems[i];
                let datetime1 = subitem.FM_DATE.split("-");
                datetime1[0] = parseInt(datetime1[0]) - 1911;
                subitem.FM_DATE = datetime1.join("-");
                this.exceldata.dataset.push(subitem);
              }
              this.priceanalysis.items = dataItems;
              // this.exceldata.dataset = dataItems
              this.totalRows = dataItems.length;
            }
            if (this.timepicker.minvalue == this.timepicker.maxvalue)
              this.perPage = this.priceanalysis.items.length;
            else this.perPage = 10;
            this.isBusy = false;
          }
        })
        .catch((err) => console.warn(err));
    },
    //  checkLogin() {
    //     let TokenID = sessionStorage.getItem("TokenID");
    //     if(TokenID){
    //         this.checkPermission()
    //     }
    //     else
    //     {
    //         alert("無權限檢視此頁面，請登入帳號")
    //         this.$router.push({ path: '/login' })
    //     }
    // },
    init() {
      this.createoptions();
      this.getFishManagementList();
      // this.settotalRows();
      // this.priceanalysis.items = [...this.priceanalysis.allitems]
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    twtimeparse(item) {
      let tt = item.split("-");
      tt[0] = parseInt(tt[0]) + 1911;
      return tt.join("-");
    },
    changetimeformat(time) {
      let tt = time.split("-");
      tt[0] = parseInt(tt[0]) - 1911;
      return tt.join("-");
    },
    uploadFile(e) {
      console.log(["檔案上傳", e]);
      const file = e.target.files[0];
      const inputEl = e.target;
      if (!file) return;

      const fileName = file.name || "";
      const fileType = file.type || "";
      const ext = fileName.includes(".")
        ? fileName.split(".").pop().toLowerCase()
        : "";
      const allowedExt = ["xls", "xlsx"];
      const allowedMimeTypes = [
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ];

      if (!allowedExt.includes(ext) && !allowedMimeTypes.includes(fileType)) {
        alert("僅允許上傳 xls、xlsx 檔案");
        inputEl.value = "";
        return;
      }
      console.log(file);
      let formdata = new FormData();
      formdata.append("Files", file);
      this.apiFishExcelUpload(formdata)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            console.log(jsonData);
            alert("上傳成功");
            this.$router.go();
          } else {
            console.warn("上傳失敗");
          }
        });
    },
    createoptions() {
      let list2 = [{ label: "全部", code: "全部" }];
      for (let i in this.fishcodelist) {
        let item1 = this.fishcodelist[i];
        let obj = {
          label: item1.FISH_NAME,
          code: item1.FISH_CODE,
        };
        list2.push(obj);
      }
      this.fishcatch.options = list2;
    },
    getFishManagementList() {
      this.isBusy = true;
      let localmintime = this.timepicker.minvalue.split("-");
      localmintime[0] = parseInt(localmintime[0]) + 1911;
      let localmaxtime = this.timepicker.maxvalue.split("-");
      localmaxtime[0] = parseInt(localmaxtime[0]) + 1911;

      let obj = {
        start_date: localmintime.join("-"),
        end_date: localmaxtime.join("-"),
      };
      this.FunctionToken(this.FishManagementList, obj);
    },
    filteritems() {
      if (this.fishcatch.value == undefined || this.fishcatch.value == null) {
        alert("請選擇搜尋條件");
      } else {
        let localmintime = this.timepicker.minvalue.split("-");
        localmintime[0] = parseInt(localmintime[0]) + 1911;
        let localmaxtime = this.timepicker.maxvalue.split("-");
        localmaxtime[0] = parseInt(localmaxtime[0]) + 1911;

        let obj = {
          start_date: localmintime.join("-"),
          end_date: localmaxtime.join("-"),
        };
        if (this.fishcatch.value.code != "全部") {
          obj["fish_code"] = this.fishcatch.value.code;
        }
        this.isBusy = true;
        this.FunctionToken(this.FishManagementList, obj);
      }
    },
    // async checkPermission() {
    //   let accountdata = { PJ_ID: "PJ000000000014", fun: this.checkshowByPJID };
    //   this.FunctionToken(this.Authority, accountdata);
    //   let databuilddata = {
    //     PJ_ID: "PJ000000000015",
    //     fun: this.checkeditdataByPJID,
    //   };
    //   this.FunctionToken(this.Authority, databuilddata);
    // },
    // checkshowByPJID(value) {
    //   if (!value) {
    //     alert("無權限檢視此頁面，將返回首頁");
    //     this.datamanagement.ifshow = false;
    //     this.$router.push({ path: "/" });
    //   } else {
    //     this.datamanagement.ifshow = true;
    //     this.FunctionToken(this.getTradeWarningCrop, {});
    //     this.settotalRows();
    //   }
    // },
    // checkeditdataByPJID(value) {
    //   if (!value) {
    //     this.datamanagement.ifedit = false;
    //   } else {
    //     this.datamanagement.ifedit = true;
    //   }
    // },
    checksave(item) {
      if (this.IsNull(item.TC_LIMIT)) {
        this.priceanalysis.additem = item;
        this.$bvModal.show("savemodal");
      }
    },
    changePage(item) {
      let value = item.item.FM_DATE.split("-");
      // value[0] = value[0] - 1911
      this.$router.push({
        name: "DataBuildAddForFishCatch",
        params: { id: value.join("-") },
      });
    },
    hideModal() {
      this.priceanalysis.additem = {};
      this.$bvModal.hide("savemodal");
    },
    getNow: function() {
      const today = new Date();
      const date =
        today.getFullYear() +
        "" +
        (today.getMonth() + 1) +
        "" +
        today.getDate();
      const time =
        today.getHours() + "" + today.getMinutes() + "" + today.getSeconds();
      const dateTime = date + "" + time;
      return "-" + dateTime;
    },
    addcount() {
      for (let i in this.priceanalysis.items) {
        this.priceanalysis.items[i]["Count"] = parseInt(i) + 1;
      }
    },
    dateDisabled(ymd, date) {
      // Disable weekends (Sunday = `0`, Saturday = `6`)
      // let y = ymd
      const weekday = date.getDay();
      // Return `true` if the date should be disabled
      return weekday === 0 || weekday === 6;
    },
    settotalRows() {
      this.totalRows = this.priceanalysis.items.length;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    suceessPopUp(msg) {
      this.messageObject.success.count = this.messageObject.dismissSecs;
      this.messageObject.success.content = msg;
    },
    successCountChanged(count) {
      this.messageObject.success.count = count;
    },
  },
  computed: {
    visibleFields() {
      return this.priceanalysis.fields.filter((field) => field.visible);
    },
  },
  watch: {
    "priceanalysis.items"() {
      this.settotalRows();
    },
    "showmanage.count"(val) {
      if (val == 3) {
        this.checkallpermission();
      }
    },
  },
  components: {
    datepicker,
  },
};
</script>

<style scoped>
.table thead th {
  vertical-align: middle !important;
  
}
.table {
  font-size: 1.3rem !important;
}
.hideheadr {
  background-color: red !important;
}
.picker {
  width: 200px;
}
</style>
